import { Users as UsersIcon } from "lucide-react";
import useReferralUserCount from "../../hooks/useUsers";
import GlassCard from "../ui/GlassCard";
import StatPill from "../ui/StatPill";

const TotalUsers = () => {
  const { employees, loading } = useReferralUserCount();

  return (
    <GlassCard accent="purple" className="text-slate-900 dark:text-white">
      <StatPill
        icon={<UsersIcon size={20} />}
        value={loading ? "..." : employees}
        label="Total Employees"
        accent="#8b7cf6"
      />
    </GlassCard>
  );
};

var Users_default = TotalUsers;
export { Users_default as default };
